(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("connext-store", [], factory);
	else if(typeof exports === 'object')
		exports["connext-store"] = factory();
	else
		root["connext-store"] = factory();
})(this, function() {
return 